












































































































































import Vue from 'vue';
import BbTools from '@/tools/bluebird';
import RoutePaths from '@/router/route_paths';

export default Vue.extend({
  computed: {
    sizeComputed(): number {
      return 25;
    },
    breadcrumbsVisible(): boolean {
      return this.$route.path !== RoutePaths.WELCOME;
    },
    homeVisible(): boolean {
      return true;
    },
    langLVisible(): boolean {
      return true;
    },
    isCoursesPersonalizedRoute(): boolean {
      return this.$route.path === RoutePaths.COURSES_PERSONALIZED;
    },
    isCoursesPersonalizedWizardRoute(): boolean {
      return this.$route.path === RoutePaths.COURSES_PERSONALIZED_WIZARD;
    },
    isRapidTestInstructionsRoute(): boolean {
      return this.$route.path === RoutePaths.RAPID_TEST_INSTRUCTIONS;
    },
    isRapidTestResultsRoute(): boolean {
      return this.$route.path === RoutePaths.RAPID_TEST_RESULTS;
    },
    isRapidTestRoute(): boolean {
      return this.$route.path === RoutePaths.RAPID_TEST;
    },
    isLevelsPersonalizedRoute(): boolean {
      return this.$route.path === RoutePaths.LEVELS_PERSONALIZED;
    },
    isLevelsRoute(): boolean {
      return this.$route.path === RoutePaths.LEVELS;
    },
    isUnitsRoute(): boolean {
      return this.$route.path === RoutePaths.UNITS;
    },
    isAudioRoute(): boolean {
      return this.$route.path === RoutePaths.AUDIO;
    },
    isQuizzesRoute(): boolean {
      return this.$route.path === RoutePaths.QUIZZES;
    },
    levelVisible(): boolean {
      return !this.isCoursesPersonalizedRoute
        && !this.isCoursesPersonalizedWizardRoute
        && !this.isRapidTestInstructionsRoute
        && !this.isRapidTestResultsRoute
        && !this.isRapidTestRoute;
    },
    coursesPersonalizedVisible(): boolean {
      return this.$store.state.personalizedCourse !== null
        || this.isCoursesPersonalizedRoute
        || this.isCoursesPersonalizedWizardRoute;
    },
    personalizedCourseVisible(): boolean {
      return this.$store.state.personalizedCourse !== null
        && (!this.isCoursesPersonalizedRoute
          || this.isCoursesPersonalizedWizardRoute);
    },
    unitVisible(): boolean {
      return !this.isLevelsRoute
        && !this.isLevelsPersonalizedRoute
        && !this.isCoursesPersonalizedRoute
        && !this.isCoursesPersonalizedWizardRoute
        && !this.isRapidTestInstructionsRoute
        && !this.isRapidTestResultsRoute
        && !this.isRapidTestRoute;
    },
    lessonVisible(): boolean {
      return !this.isLevelsRoute
        && !this.isUnitsRoute
        && !this.isCoursesPersonalizedRoute
        && !this.isLevelsPersonalizedRoute
        && !this.isCoursesPersonalizedWizardRoute
        && !this.isRapidTestInstructionsRoute
        && !this.isRapidTestResultsRoute
        && !this.isRapidTestRoute;
    },
    labelSelectLesson(): string {
      return `${this.$store.state.tr.Select} ${BbTools.replaceAll(this.$store.state.tr.Lesson, '##lesson_number##', '')}`;
    },
    drillTitle(): string {
      if (this.$route.path.startsWith(RoutePaths.DRILL_VOICECOMPARISON)) {
        return this.$store.state.tr.VoiceComparison;
      }
      if (this.$route.path.startsWith(RoutePaths.DRILL_PRONUNCIATIONANALYSIS)) {
        return this.$store.state.tr.PronunciationAnalysis;
      }
      if (this.$route.path.startsWith(RoutePaths.DRILL_VIDEO)) {
        return this.$store.state.tr.Video;
      }
      return '';
    },
  },
  methods: {
    clearLessons(): void {
      this.$store.commit('setLesson', null);
      this.$store.commit('setLessons', []);
    },
    clearUnits(): void {
      this.$store.commit('setUnit', null);
      this.$store.commit('setUnits', []);
    },
    clearLevels(): void {
      this.$store.commit('setLevel', null);
      this.$store.commit('setLevels', []);
    },
    clearLevelsDaily(): void {
      this.$store.commit('setLevelsPersonalized', []);
      this.$store.commit('setLevelDaily', null);
    },
    clearLevelsPersonalized(): void {
      this.$store.commit('setLevel', null);
      this.$store.commit('setLevelsPersonalized', []);
      this.$store.commit('setPersonalizedCourse', null);
    },
    clearCoursesPersonalized(): void {
      this.$store.commit('setPersonalizedCourse', null);
      this.$store.commit('setCoursesPersonalized', []);
    },
    onHome(): void {
      this.clearLessons();
      this.clearUnits();
      this.clearLevels();
      this.clearLevelsDaily();
      this.clearCoursesPersonalized();
      this.$router.push(RoutePaths.WELCOME);
    },
    onLang(): void {
      this.clearLessons();
      this.clearUnits();
      this.clearLevels();
      this.clearLevelsDaily();
      this.clearCoursesPersonalized();
      this.$router.push({
        path: RoutePaths.WELCOME,
        query: {
          noInit: 'true',
        },
      });
    },
    onLevel(): void {
      this.clearLessons();
      this.clearUnits();
      this.$store.commit('setLevel', null);
      if (this.$store.state.personalizedCourse) {
        this.$router.push({
          path: RoutePaths.LEVELS_PERSONALIZED,
          query: {
            noInit: 'true',
          },
        });
      } else {
        this.$router.push({
          path: RoutePaths.LEVELS,
          query: {
            noInit: 'true',
          },
        });
      }
    },
    onCoursesPersonalized(): void {
      this.clearLessons();
      this.clearUnits();
      this.clearLevelsPersonalized();
      this.$router.push({
        path: RoutePaths.LEVELS,
        query: {
          noInit: 'true',
        },
      });
    },
    onPersonalizedCourse(): void {
      this.clearLessons();
      this.clearUnits();
      this.clearLevelsPersonalized();
      this.$router.push({
        path: RoutePaths.COURSES_PERSONALIZED,
        query: {
          noInit: 'true',
        },
      });
    },
    onRapidTestInstructions(): void {
      this.clearLessons();
      this.clearUnits();
      this.clearLevelsPersonalized();
      this.$router.push({
        path: RoutePaths.LEVELS,
        query: {
          noInit: 'true',
        },
      });
    },
    onRapidTestResults(): void {
      this.clearLessons();
      this.clearUnits();
      this.clearLevelsPersonalized();
      this.$router.push({
        path: RoutePaths.LEVELS,
        query: {
          noInit: 'true',
        },
      });
    },
    onUnit(): void {
      this.$store.commit('setUnit', null);
      this.clearLessons();
      this.$router.push({
        path: RoutePaths.UNITS,
        query: {
          noInit: 'true',
        },
      });
    },
    onLesson(): void {
      this.$store.commit('setLesson', null);
      this.$router.push({
        path: RoutePaths.LESSONS,
        query: {
          noInit: 'true',
        },
      });
    },
  },
});
